import moment from 'moment/moment';
import connector from '../../public/src/img/office/challenge/connector.png';
import connectorColor from '../../public/src/img/office/challenge/connectorColor.png';
import dating from '../../public/src/img/office/challenge/dating.png';
import datingColor from '../../public/src/img/office/challenge/datingColor.png';
import exelent from '../../public/src/img/office/challenge/exelent.png';
import exelentColor from '../../public/src/img/office/challenge/exelentColor.png';
import financier from '../../public/src/img/office/challenge/financier.png';
import financierColor from '../../public/src/img/office/challenge/financierColor.png';
import insider from '../../public/src/img/office/challenge/insider.png';
import insiderColor from '../../public/src/img/office/challenge/insiderColor.png';
import lightstart from '../../public/src/img/office/challenge/lightstart.png';
import lightstartColor from '../../public/src/img/office/challenge/lightstartColor.png';
import partner from '../../public/src/img/office/challenge/partner.png';
import partnerColor from '../../public/src/img/office/challenge/partnerColor.png';
import verification from '../../public/src/img/office/challenge/verification.png';
import verificationColor from '../../public/src/img/office/challenge/verificationColor.png';
import { userInfo } from '../../common/utils/memo';

import T, { t } from '../../common/components/T';
import uikit from '../../project/uikit/styles';
import { mediaSkeleton } from '../../widgets/plug/Skeleton/components/patterns';
import { navigateV2 } from '../../common/utils/router';
import Display from '../../common/components/Display';

export const challengesBackgrounds = () => [
    {
        style: { 'background-color': 'var(--greyBlueLightColor)' },
        img: dating,
        imgColor: datingColor
    },
    {
        style: { 'background-color': 'var(--beigeColor)' },
        img: lightstart,
        imgColor: lightstartColor
    },
    {
        style: { 'background-color': 'var(--greyLightColor)' },
        img: exelent,
        imgColor: exelentColor
    },
    {
        style: { 'background-color': 'var(--greyBlueColor)' },
        img: verification,
        imgColor: verificationColor
    },
    {
        style: { 'background-color': 'var(--beigeColor)' },
        img: connector,
        imgColor: connectorColor
    },
    {
        style: { 'background-color': 'var(--greyBlueDarkColor)' },
        img: partner,
        imgColor: partnerColor
    },
    {
        style: { 'background-color': 'var(--greyWhiteColor)' },
        img: financier,
        imgColor: financierColor
    },
    {
        style: { 'background-color': 'var(--greyGreenColor)' },
        img: insider,
        imgColor: insiderColor
    }
];

export const getPersonalProgressSlider = (data) => ({
    dots: true,
    arrows: false,
    slidesToShow: data.length < 3 ? data.length : 3,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1800,
            settings: {
                slidesToShow: data.length < 2 ? data.length : 2,
                slidesToScroll: data.length < 2 ? data.length : 2
            }
        },
        {
            breakpoint: 1420,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: data.length < 2 ? data.length : 2,
                slidesToScroll: data.length < 2 ? data.length : 2
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: data.length < 2 ? data.length : 2,
                slidesToScroll: data.length < 2 ? data.length : 2
            }
        }
    ]
});

export function getIsEmptyStat(data) {
    let status = true;
    // if (!data?.comparison_period) {
    //     return status;
    // }
    if (!data?.stats) {
        return status;
    }
    let atLeastOneStat = Object.values(data?.stats).some((el) => Number(el?.number) > 0 || Number(el?.comparison_number) > 0);
    if (!atLeastOneStat) {
        return status;
    }
    return !status;
}

export const getPersonalRank = (data, trans) => {
    return {
        title: t('lineProgressTitleBranches-office', 'Квалифицированных веток в ранге', '/office', trans),
        have: !!data?.current_rank ? data?.current_rank : false,
        next: !!data?.next_rank ? data?.next_rank : false,
        partners: {
            set: data?.conditions?.branches_with_rank?.number,
            max: data?.conditions?.branches_with_rank?.target_number
        }
    };
};
export const getPersonalLine = (data, trans) => {
    return {
        title: t('lineProgressTitleBranches-office', 'Квалифицированных веток в ранге', '/office', trans),
        have: data?.current_rank || data?.conditions?.branches_with_rank?.target_rank || false,
        next: data?.next_rank ? data?.next_rank : false,
        partners: {
            set: data?.conditions?.branches_with_rank?.number,
            max: data?.conditions?.branches_with_rank?.target_number
        }
    };
};
export const getPersonalLineStructure = (data, trans) => {
    return {
        title: t('lineProgressTitleBranchesStructure-office', 'Лично приглашенных в бинаре в ранге', '/office', trans),
        have: data?.conditions?.structure_branches_with_rank?.target_rank || false,
        partners: {
            set: data?.conditions?.structure_branches_with_rank?.target_count?.slice(0, 2).map((el, i) => {
                if (data?.conditions?.structure_branches_with_rank?.count?.[i]) {
                    return data?.conditions?.structure_branches_with_rank?.count[i];
                }
                return 0;
            }),
            max: data?.conditions?.structure_branches_with_rank?.target_count?.slice(0, 2)
        }
    };
};
export const getActivityDate = (data) => {
    let start = data?.period?.formatted_date_from;
    let end = data?.period?.formatted_date_to;
    return {
        start: start,
        end: end
    };
};
export const getVolumes = (data) => {
    let arr = [];
    !!data?.conditions?.volumes &&
        data?.conditions?.volumes.map((volumesItem) => {
            arr.push({
                title: volumesItem.symbol,
                target: Number(volumesItem.target),
                hasPV: Number(volumesItem.accumulated),
                formatted_target: volumesItem.formatted_target,
                formatted_accumulated: volumesItem.formatted_accumulated,
                formatted_left_to_accumulate: volumesItem.formatted_left_to_accumulate,
                name: volumesItem.name
            });
        });
    return arr;
};

export const getTitleDate = (period, setDateForTitle) => {
    let start = period?.start?.split(' ')[0].split('-');
    let end = !!period.end ? period.end.split(' ')[0].split('-') : start;
    if (!!start) {
        setDateForTitle(
            !period?.allPeriod
                ? start[0].length > 2
                    ? {
                          start: start[2] + '.' + start[1] + '.' + start[0],
                          end: !!period.end ? end[2] + '.' + end[1] + '.' + end[0] : null
                      }
                    : {
                          start: start[0] + '.' + start[1] + '.' + start[2],
                          end: !!period.end ? end[0] + '.' + end[1] + '.' + end[2] : null
                      }
                : {
                      start: null,
                      end: null
                  }
        );
    }
};

export const getTransformPeriod = (period, time) => {
    if (period.start === '' && period.end === '') {
        period = {
            start: time().add(-1, 'years').format('YYYY-MM-DD 00:mm:ss'),
            end: time().format('YYYY-MM-DD 00:mm:ss'),
            allPeriod: true
        };
    }
    let start = period?.start?.split(' ')[0]?.split('-');
    let end = !!period.end ? period?.end?.split(' ')[0]?.split('-') : start;

    return {
        data:
            start && start[0].length > 2
                ? {
                      start: start && moment(new Date(start[0], start[1] - 1, start[2])).format('YYYY-MM-DD 00:mm:ss'),
                      end: end && moment(new Date(end[0], end[1] - 1, end[2])).format('YYYY-MM-DD 23:59:59')
                  }
                : {
                      start: start && moment(new Date(start[2], start[1] - 1, start[0])).format('YYYY-MM-DD 00:mm:ss'),
                      end: end && moment(new Date(end[2], end[1] - 1, end[0])).format('YYYY-MM-DD 23:59:59')
                  },
        title: !period?.allPeriod
            ? start && start[0].length > 2
                ? {
                      start: start[2] + '.' + start[1] + '.' + start[0],
                      end: !!period.end ? end[2] + '.' + end[1] + '.' + end[0] : null
                  }
                : {
                      start: start && start[0] + '.' + start[1] + '.' + start[2],
                      end: !!period?.end ? end[0] + '.' + end[1] + '.' + end[2] : null
                  }
            : {
                  start: null,
                  end: null
              }
    };
};

export const getDataTable = (data, width) => {
    let thead = [
        {
            name: 'orderBuyer',
            type: 'login',
            title: <T textName='pageOffice-gridThead-1-new' defaultStr='ФИО, ID' page='/office' />
        },
        {
            name: 'package',
            type: 'package',
            title: <T textName='personal_package' defaultStr='Пакет' page='/office' />,
            align: 'left'
        },
        {
            name: 'activity',
            type: 'activity',
            title: <T textName='officeLastRegisters-thead-status' defaultStr='Статус' page='/office' />,
            align: 'left'
        },
        {
            name: 'branch',
            type: 'branch',
            title: <T textName='officeLastRegisters-thead-branch' defaultStr='Ветка' page='/office' />,
            align: 'left'
        },
        {
            name: 'orderDate',
            type: 'text',
            align: 'left',
            title: <T textName='pageOffice-gridThead-2-new' defaultStr='Дата регистрации' page='/office' />
        },
        {
            name: 'contacts',
            title: width < 1200 ? '' : <T textName='pageOffice-gridThead-4-new' defaultStr='Действия' page='/office' />,
            type: 'contacts',
            showOnlyDots: width < 1200
        }
    ];
    // moment(new Date('20' + item.partner.formatted_created_at.split(' ')[0].split('.')[2], item.partner.formatted_created_at.split(' ')[0].split('.')[1], item.partner.formatted_created_at.split(' ')[0].split('.')[0])).format('DD MMM YYYY')
    let tbody = [];
    data &&
        data.map((item) => {
            tbody.push({
                orderBuyer: item.partner,
                package: item.partner.package || item.package || false,
                activity: item.partner?.marketing_profile?.activity,
                branch: item.partner?.marketing_profile?.position,
                orderDate: item.partner.created_at_formatted,
                contacts: {
                    ...item?.partner?.contacts,
                    showOnlyDots: width < 1200
                },
                id: item.partner.id
            });
        });

    return {
        thead: { data: thead },
        tbody: { data: tbody }
    };
};

export const dataPieChart = (bonus) => {
    if (!bonus?.data) {
        return [];
    }
    let sortBonus = [...bonus?.data].sort((a, b) => +b.amount - +a.amount);

    const valuesLength = bonus?.data?.filter((b) => +b.amount)?.length;
    const getStepForVarPie = (l) => {
        switch (l) {
            case 1:
                return 100;
            case 2:
                return 40;
            default:
                return (100 - 10) / (l - 1);
        }
    };
    let steepForVarPie = getStepForVarPie(valuesLength); //рассчет шага ступенек для круговой диаграми для Web-версии
    let bonusList = [];
    let index = 0;
    sortBonus.map((bonusItem) => {
        bonusList.push({
            name: bonusItem.bonus_name,
            y: +bonusItem.amount,
            z: +bonusItem.amount ? (!index ? 100 : 100 - steepForVarPie * index) : 0,
            formatted_sum: bonusItem.formatted_amount,
            currency_code: bonusItem.currency_code || 'PV',
            period: bonusItem.period
        });

        if (bonusItem.sum) {
            index++;
        }
    });
    return bonusList;
};

export const dataPackages = (data, period, lang, dateFormat) => {
    let periods = data?.data
        ?.map((item) => ({
            marketing_package_id: item.marketing_package_id,
            name: item.package
        }))
        .filter((item, index, arr) => arr.indexOf(item) === index)
        .sort((a, b) => a.marketing_package_id - b.marketing_package_id);
    let uniqPeriods = [...new Set(periods?.map((item) => item.name))].map((item) => ({
        name: item,
        marketing_package_id: periods.find((per) => item === per.name).marketing_package_id
    }));

    let dataChart = [];
    let datePeriod = [];
    let dataPackages = {};
    let packageNames = {};
    let start = !!period.start ? period.start.split(' ')[0].split('-') : '';
    let end = !!period?.end ? period.end.split(' ')[0].split('-') : start;
    uniqPeriods?.map((summaryItem) => {
        packageNames[summaryItem?.marketing_package_id] = summaryItem?.name;
    });

    data?.data?.map((dataItem) => {
        //START
        let data = {};
        data[dataItem?.period] = dataItem?.count;

        dataPackages[packageNames[dataItem.marketing_package_id]] = {
            ...dataPackages[packageNames[dataItem.marketing_package_id]],
            ...data
        };
    });

    if (data?.meta?.group_period === 'day') {
        for (let i = 0; i <= Number(moment(period.end).diff(moment(period.start), 'days')); i++) {
            datePeriod.push(moment(period.start).add(i, 'days').format(dateFormat));
            // ?.replace('.', ''));
        }
        Object.keys(dataPackages).map((packageItem) => {
            const findIdOfPackages = Object.keys(packageNames).find((item) => packageNames[item] === packageItem);
            let packageName = packageItem;
            let packageCountToDate = [];
            let dateStart = moment(new Date(start[0], start[1] - 1, start[2])).format('YYYY-MM-DD');
            let dateEnd = moment(new Date(end[0], end[1] - 1, Number(end[2]) + 1)).format('YYYY-MM-DD');
            for (let i = 1; moment(dateEnd).isAfter(dateStart); i++) {
                !!dataPackages[packageItem][dateStart]
                    ? packageCountToDate.push(dataPackages[packageItem][dateStart])
                    : packageCountToDate.push(0);
                dateStart = moment(new Date(start[0], start[1] - 1, Number(start[2]) + i)).format('YYYY-MM-DD');
            }
            dataChart.push({
                name: packageName,
                data: packageCountToDate,
                maxPointWidth: 8,
                id: +findIdOfPackages
            });
        });
    }

    if (data?.meta?.group_period === 'month') {
        let formatSeparator = '/';
        switch (true) {
            case dateFormat?.includes('/'):
                formatSeparator = '/';
                break;
            case dateFormat?.includes('-'):
                formatSeparator = '-';
                break;
            case dateFormat?.includes('.'):
                formatSeparator = '.';
                break;
            case dateFormat?.includes(','):
                formatSeparator = ',';
                break;
            default:
                break;
        }
        for (let i = 0; i <= Number(moment(period.end).diff(moment(period.start), 'month')); i++) {
            datePeriod.push(moment(period.start).add(i, 'month').format(`MM${formatSeparator}YYYY`));
        }
        Object.keys(dataPackages).map((packageItem) => {
            const findIdOfPackages = Object.keys(packageNames).find((item) => packageNames[item] === packageItem);
            let packageName = packageItem;
            let packageCountToDate = [];
            let dateStart = moment(new Date(start[0], start[1] - 1, start[2])).format('YYYY-M');
            let dateEnd = moment(new Date(end[0], end[1] - 1, end[2])).format('YYYY-M');
            const getValues = (dateStart) => {
                const [yearS, monthS] = dateStart.split('-');
                const [yearE, monthE] = dateEnd.split('-');
                if (Number(yearS) < Number(yearE)) {
                    return true;
                } else if (Number(yearS) === Number(yearE) && Number(monthS) <= Number(monthE)) {
                    return true;
                }
                return false;
            };
            for (let i = 1; getValues(dateStart); i++) {
                !!dataPackages[packageItem][dateStart]
                    ? packageCountToDate.push(dataPackages[packageItem][dateStart])
                    : packageCountToDate.push(0);
                dateStart = moment(new Date(start[0], Number(start[1] - 1) + i)).format('YYYY-M');
            }
            dataChart.push({
                name: packageName,
                data: packageCountToDate,
                maxPointWidth: 8,
                id: +findIdOfPackages
            });
        });
    }

    if (data?.meta?.group_period === 'year') {
        for (let i = 0; i <= Number(moment(period.end).diff(moment(period.start), 'year')); i++) {
            datePeriod.push(moment(period.start).add(i, 'year').format('YYYY '));
        }
        Object.keys(dataPackages).map((packageItem) => {
            const findIdOfPackages = Object.keys(packageNames).find((item) => packageNames[item] === packageItem);
            let packageName = packageItem;
            let packageCountToDate = [];
            let dateStart = moment(new Date(start[0], start[1] - 1, start[2])).format('YYYY');
            let dateEnd = moment(new Date(end[0], end[1] - 1, end[2])).format('YYYY');
            for (let i = 1; Number(dateStart) <= Number(dateEnd); i++) {
                !!dataPackages[packageItem][dateStart]
                    ? packageCountToDate.push(dataPackages[packageItem][dateStart])
                    : packageCountToDate.push(0);
                dateStart = moment(new Date(Number(start[0]) + i, Number(start[1]))).format('YYYY');
            }
            dataChart.push({
                name: packageName,
                data: packageCountToDate,
                maxPointWidth: 8,
                id: +findIdOfPackages
            });
        });
    }
    dataChart
        ?.sort((a, b) => a.id - b.id)
        .sort((b, a) =>
            b?.data?.length && a?.data?.length
                ? a.data.reduce((acc, elm) => acc + elm) - b.data.reduce((acc, elm) => acc + elm)
                : -1
        );

    return {
        data: dataChart,
        period: datePeriod
    };
};

export const handleUserInfo = async (rowData, setShowUser, setUserData, userToken, lang) => {
    if (!rowData) return;
    setShowUser(true);
    const data = await userInfo(rowData, userToken, lang, setUserData);
    setUserData(data);
};
export const getNewsSkeleton = (key) => [
    {
        row: mediaSkeleton(
            key,
            {
                991: [25, 25, 25, 25],
                767: [33, 33, 33],
                575: [50, 50]
            },
            [100]
        ),
        items: [
            {
                row: [100],
                itemsStyles: {
                    borderRadius: '20px',
                    background: 'var(--whiteColor)',
                    overflow: 'hidden'
                },
                items: [
                    {
                        content: [
                            'image',
                            {
                                row: [90],
                                items: [
                                    {
                                        type: 'text',
                                        gap: [0, 0, 1, 0]
                                    }
                                ],
                                indent: 3
                            },
                            {
                                row: [80],
                                items: ['text'],
                                indent: 3
                            },
                            'empty',
                            'line',
                            {
                                row: [29, 19, 5, 49],
                                items: ['text', 'text', 'empty', 'text'],
                                gap: 2,
                                indent: 3
                            }
                        ]
                    }
                ]
            }
        ],
        gap: 2
    },
    'button'
];
export const activitySkeleton = [
    {
        row: [40, 20],
        items: [
            {
                content: [
                    {
                        type: 'title',
                        width: 90,
                        gap: [0, 0, 1, 0]
                    },
                    'small'
                ]
            },
            'blockSM'
        ]
    },
    'blockSM',
    'blockSM',
    'blockLG',
    {
        type: 'blockSM',
        gap: [0, 0, 3, 0]
    },
    'blockXL',
    {
        type: 'blockXL',
        gap: [0, 0, 0, 0]
    }
];
export const bonusesSkeleton = [
    {
        row: [40, 50],
        items: [
            {
                content: [
                    'subtitle',
                    {
                        type: 'list',
                        width: 50,
                        size: { rows: 1 }
                    }
                ]
            },
            {
                content: [
                    {
                        type: 'icon',
                        align: 'right'
                    }
                ]
            }
        ],
        indent: 3
    },
    {
        row: [50, 50],
        items: [
            {
                content: [
                    {
                        type: 'list',
                        size: {
                            rows: 5,
                            width: [62, 40, 70, 80, 60]
                        }
                    },
                    'blockXL'
                ]
            },
            {
                content: [
                    ,
                    {
                        type: 'circle',
                        diameter: 10,
                        align: 'center'
                    }
                ]
            }
        ],
        indent: 3
    },
    'line',
    {
        type: 'text',
        width: 10,
        align: 'center'
    }
];
export const getPackagesSkeleton = () => [
    {
        row: [25, 25, 25, 25],
        items: [
            {
                row: [100],
                itemsStyles: {
                    padding: '1rem',
                    borderRadius: '20px',
                    background: 'var(--whiteColor)',
                    overflow: 'hidden'
                },
                items: [
                    {
                        content: [
                            {
                                type: 'title',
                                width: 50
                            },
                            {
                                type: 'text',
                                width: 33,
                                gap: [0, 0, 1, 0]
                            },
                            {
                                type: 'title',
                                width: 28,
                                mode: 'light'
                            },
                            {
                                type: 'text',
                                width: 33,
                                gap: [0, 0, 1, 0]
                            },
                            {
                                type: 'title',
                                width: 40,
                                mode: 'light'
                            },
                            {
                                type: 'blockSM',
                                gap: 0
                            }
                        ]
                    }
                ]
            }
        ],
        gap: 2
    },
    'empty'
];
export const packagesStatsSkeletonGraph = [
    {
        row: [25, 75],
        items: [
            {
                type: 'list',
                size: {
                    rows: 5,
                    width: [25, 30, 40, 28, 50]
                }
            },
            'chart'
        ],
        indent: 3
    }
];
export const packagesStatsSkeleton = [
    {
        row: [55, 'auto'],
        items: [
            {
                content: [
                    'text',
                    {
                        type: 'list',
                        width: 50,
                        size: { rows: 1 }
                    }
                ]
            },
            'icon'
        ],
        indent: 3
    },
    ...packagesStatsSkeletonGraph,
    'line',
    {
        type: 'text',
        width: 10,
        align: 'center'
    }
];
export const progressSkeleton = [
    {
        row: [20],
        items: ['title']
    },
    {
        row: [30, 'auto', 30],
        gap: 1,
        items: ['blockLG', 'icon', 'blockLG'],
        align: 'left'
    },
    {
        type: 'text',
        width: 60
    },
    'blockSM',
    'blockLG',
    {
        row: [33, 33, 33],
        items: [
            {
                content: [
                    {
                        type: 'circle',
                        align: 'center',
                        diameter: 8
                    },
                    {
                        type: 'small',
                        align: 'center',
                        width: 33
                    },
                    {
                        type: 'small',
                        align: 'center',
                        width: 33
                    }
                ]
            }
        ]
    }
];
export const topLeadersSkeleton = [
    {
        row: [55, 'auto'],
        items: [
            {
                content: [
                    'subtitle',
                    {
                        type: 'small',
                        width: 30
                    }
                ]
            },
            'icon'
        ]
    },
    'blockLG',
    {
        row: [10, 64, 10, 10],
        items: ['small', 'empty', 'small', 'small']
    },
    'line',
    {
        row: [10, 28, 36, 10, 10],
        gap: 2,
        items: [
            'circle',
            'text',
            'empty',
            {
                type: 'small',
                width: 50,
                align: 'center'
            },
            {
                type: 'small',
                width: 50,
                align: 'center'
            }
        ]
    },
    {
        row: [10, 28, 36, 10, 10],
        gap: 2,
        items: [
            'circle',
            'text',
            'empty',
            'small',
            {
                type: 'small',
                width: 50,
                align: 'center'
            }
        ]
    },
    {
        row: [10, 28, 36, 10, 10],
        gap: 2,
        items: [
            'circle',
            'text',
            'empty',
            {
                type: 'small',
                width: 50,
                align: 'center'
            },
            'small'
        ]
    },
    {
        itemsStyles: { height: '2.5rem' },
        row: [10, 28, 36, 10, 10],
        gap: 2,
        items: [
            'empty',
            'text',
            'empty',
            'small',
            {
                type: 'small',
                width: 50,
                align: 'center'
            }
        ]
    },
    {
        itemsStyles: { height: '2.5rem' },
        row: [10, 28, 36, 10, 10],
        gap: 2,
        items: [
            'empty',
            'text',
            'empty',
            {
                type: 'small',
                width: 50,
                align: 'center'
            },
            'small'
        ]
    }
];
export const getWalletsSkeleton = () => [
    {
        row: [100],
        items: [
            {
                row: [100],
                itemsStyles: {
                    padding: '2rem',
                    borderRadius: '36px',
                    background: 'var(--whiteColor)',
                    overflow: 'hidden',
                    ...uikit.mb2,
                    width: '100%'
                },
                items: [
                    {
                        content: [
                            {
                                row: [40, 50, 10],
                                items: ['title', 'empty', 'circle']
                            },
                            {
                                type: 'blockMD',
                                width: 90
                            },
                            'empty',
                            {
                                type: 'text',
                                width: 90
                            },
                            'empty',
                            'empty',
                            'line',
                            'empty',
                            'empty',
                            {
                                row: [40, 50, 10],
                                items: ['title', 'empty', 'circle']
                            },
                            {
                                type: 'blockMD',
                                width: 90
                            },
                            'empty',
                            {
                                type: 'text',
                                width: 90
                            }
                        ]
                    }
                ]
            }
        ],
        gap: 2
    }
];

export const getUserNotification = (profileData, roles, minPricePackage, showSponsorModal) => {
    const hasClientRole =
        Array.isArray(roles) && roles?.some((role) => ['gtuser::client', 'gtuser::full_client'].includes(role?.name));
    const personalVolume = +profileData?.['marketing_profile']?.['total_personal_volume']?.['value'];
    const neededVolume = (
        <span style={{ whiteSpace: 'nowrap' }}>
            <Display
                type='value'
                data={{
                    value: minPricePackage - +profileData?.['marketing_profile']?.['total_personal_volume']?.['value'],
                    currency: { code: 'PV', symbol: 'PV' }
                }}
            />
        </span>
    );
    switch (true) {
        case Boolean(!hasClientRole): {
            return {
                title: (
                    <T
                        textName='to-access-to-office-alert-2'
                        defaultStr='Для доступа в личный кабинет необходимо приобрести пакет.'
                        page='/office'
                    />
                ),
                icon: 'warning-rhombus',
                buttonText: <T textName='go-store' defaultStr='Перейти в магазин' page='/office' />,
                buttonFunc: () => navigateV2('/store')
            };
        }
        case Boolean(personalVolume < minPricePackage && !profileData['marketing_profile']?.['package']): {
            if (profileData['marketing_profile']?.['without_sponsor']) {
                return {
                    title: (
                        <T
                            vars={{
                                neededVolume,
                                personalVolume: profileData?.['marketing_profile']?.['total_personal_volume']?.['formatted_value']
                            }}
                            textName='to-access-to-office-alert-3'
                            defaultStr='Вы совершили покупку на ${personalVolume}. Для доступа в личный кабинет и участия в партнерской программе, необходимо докупить товаров на сумму ${neededVolume} и выбрать рекомендателя.'
                            page='/office'
                        />
                    ),
                    icon: 'warning-rhombus',
                    buttonText: <T textName='go-store' defaultStr='Перейти в магазин' page='/office' />,
                    buttonFunc: () => navigateV2('/store')
                };
            }
            return {
                title: (
                    <T
                        vars={{
                            neededVolume,
                            personalVolume: profileData?.['marketing_profile']?.['total_personal_volume']?.['formatted_value']
                        }}
                        textName='to-access-to-office-alert-3-1'
                        defaultStr='Вы совершили покупку на ${personalVolume}. Для доступа в личный кабинет и участия в партнерской программе, необходимо докупить товаров на сумму ${neededVolume}.'
                        page='/office'
                    />
                ),
                icon: 'warning-rhombus',
                buttonText: <T textName='go-store' defaultStr='Перейти в магазин' page='/office' />,
                buttonFunc: () => navigateV2('/store')
            };
        }
        case Boolean(profileData['marketing_profile']?.['package'] && profileData['marketing_profile']?.['without_sponsor']): {
            return {
                title: (
                    <T
                        textName='to-access-to-office-alert-4'
                        defaultStr='Для участия в партнерской программе укажите своего рекомендателя'
                        page='/office'
                    />
                ),
                icon: 'warning-rhombus',
                buttonText: <T textName='specify_a_recommender' defaultStr='Указать рекомендателя' page='/office' />,
                buttonFunc: () => showSponsorModal(true)
            };
        }
        default: {
            return null;
        }
    }
};
